import React from "react";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";

import styles from "./CreateSparePartModal.module.scss";
import Title from "@components/global/new/Title/Title";
import Checkbox from "@components/global/new/Checkbox/Checkbox";
import Field from "@components/global/new/Field/Field";
import { useIntl } from "react-intl";
import LocationSelector from "@components/global/new/LocationSelector/LocationSelector";
import FieldArea from "@components/global/new/FieldArea/FieldArea";
import Quantity from "./Quantity/Quantity";
import PhotoUploader from "./PhotoUploader/PhotoUploader";

interface ICreateSparePartModalProps extends CommonModalPropsI {
  readonly isEdit?: boolean;
}
function CreateSparePartModal(props: ICreateSparePartModalProps) {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.wrapper}>
      <div className={styles.title_wrapper}>
        <Title className={styles.title}>
          {formatMessage({ id: "modal.spare_part.title" })}
        </Title>
      </div>

      <form className={styles.content}>
        <div>
          <Field
            type='text'
            name={formatMessage({ id: "modal.spare_part.name.title" })}
          />
          <Checkbox
            style={{
              marginTop: "10px",
            }}
            text={formatMessage({ id: "modal.spare_part.save_template" })}
          />
        </div>
        <div className={styles.edit_wrapper}>
          <Field
            type='text'
            name={formatMessage({ id: "modal.spare_part.name.owner" })}
            disabled
            readOnly
            value={"Admin"}
          />
          {!props.isEdit && <Quantity />}
        </div>

        <LocationSelector
          name={formatMessage({ id: "modal.spare_part.name.location" })}
          id='location'
        />

        <div className={styles.comment_wrapper}>
          <label>
            {formatMessage({ id: "modal.spare_part.name.comments" })}
          </label>
          <textarea />
        </div>

        <PhotoUploader />
      </form>
    </div>
  );
}

export default WithModal(
  MODALS_ENUM.CREATE_SPARE_PART_MODAL,
  CreateSparePartModal
);
